import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

export const ChatContextMenuItemSkeleton = () => (
  <div className="flex items-center px-2 py-1.5">
    <Skeleton className="h-5 w-full" />
  </div>
);
